import { Component, OnInit } from '@angular/core';
import {ValveData} from "../valvedosagemodel";
import { process } from "@progress/kendo-data-query";
import {dummy_valvedata} from "./dummy_valvedata";
import {AggregateDescriptor, State} from "@progress/kendo-data-query";
import {GroupDescriptor} from "@progress/kendo-data-query/dist/npm/grouping/group-descriptor.interface";
import {ActivatedRoute, Router} from "@angular/router";
import {ExcelExportData} from "@progress/kendo-angular-excel-export";
import {ValveRunDosageDataService} from "../valve_dosagerun_dataservice";

@Component({
  selector: 'app-irrigation-valve',
  templateUrl: './irrigation-valve.component.html',
  styleUrls: ['./irrigation-valve.component.css']
})
export class IrrigationValveComponent implements OnInit {
  public gridValveData: ValveData[] = Array(); // dummy_valvedata :: Use this is u need some dummy data

  public aggregates: AggregateDescriptor[] = [
    { field: "realised_volume_ml", aggregate: "sum" },

  ];

  // Convert ML into liters
  MlToLiters(mlInput: number):number
  {
    return mlInput / 1000;
  }
  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: process(this.gridValveData, {
        group: this.group,
        sort: [{ field: "valve", dir: "asc" }],
      }).data,
      group: this.group,
    };

    return result;
  }

  group: Array<GroupDescriptor> =  [{ field: "valve", aggregates: this.aggregates }];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private valveRunDosageData: ValveRunDosageDataService
  ) {
    this.allData = this.allData.bind(this);

    this.valveRunDosageData.GetData().subscribe(
      {
        next: gridValveData => {
          this.gridValveData = gridValveData;
        }
      });

  }


  EpochToTime(epoch: number): Date {
    return new Date(epoch * 1000);
  }


  Home() {
    this.router.navigate(['/cards', {filelink: 9999}]);
  }

  ngOnInit(): void {
  }

}
